<template lang="pug">
.user-table
  v-container(fluid)
    v-layout.mb-4(wrap)
      v-flex(
        xs12
        lg4)
        v-text-field(
          v-model="search"
          append-icon="search"
          label="搜尋關鍵字"
          single-line
          hide-details
          box)
    v-layout
      v-flex
        v-data-table(
          :headers="headers"
          :items="items"
          :search="search"
          :rows-per-page-items="[10, 25, {'text': '全部', 'value': -1 }]"
          item-key="value")
          template(v-slot:items="props")
            td.text-xs-center
              v-btn(
                color="primary"
                flat
                small
                icon
                @click="openInfo(props.item)")
                v-icon visibility
            td.text-xs-center(v-if="editable")
              v-btn(
                color="warning"
                flat
                small
                icon
                @click="openSheet(props.item)")
                v-icon edit
            td.text-xs-center {{ props.item.displayName }}
            td.text-xs-center {{ props.item.firstName }}
            td.text-xs-right {{ props.item.number }}
            td.text-xs-center
              v-chip(
                v-for="job in props.item.jobs"
                :key="job"
                color="primary"
                text-color="white"
                disabled) {{ job }}
            td.text-xs-center {{ props.item.region | regionFilter }}
            td.text-xs-center {{ props.item.gender | genderFilter }}
            td.text-xs-left
              template(v-if="props.item.lastYearReceipts")
                v-chip(
                  v-for="item in props.item.lastYearReceipts"
                  disabled)
                  v-avatar(
                    color="green"
                    text-color="white") {{ item.year }}
                  .detail {{ item | receiptItemFilter }}
            td.text-xs-center
              div(style="width: 100px;") {{ props.item.career }}
            td.text-xs-center {{ props.item.homeland }}
            td.text-xs-center {{ props.item.birth | timestampFilter }}
            td.text-xs-center {{ props.item.email }}
            td.text-xs-center {{ props.item.phoneNumber }}
            td.text-xs-center {{ props.item.phoneNumber_2 }}
            td.text-xs-left
              div(style="width: 250px;") {{ props.item.address }}
            td.text-xs-center {{ props.item.zipCode }}
            td.text-xs-center {{ props.item.remarks }}
            td.text-xs-center {{ props.item.tshirtSize }}
            td.text-xs-center {{ props.item.hide ? '是' : '否' }}
            td.text-xs-left {{ props.item.uid }}
  v-bottom-sheet(v-model="sheet")
    v-list
      v-subheader 選擇動作
      v-list-tile(
        v-for="action in activeActions"
        :key="action.title"
        @click="openDialog(action)")
        v-list-tile-title {{ action.title }}
  v-dialog(
    v-model="dialog"
    persistent)
    v-card
      v-toolbar(
        dark
        color="indigo")
        v-toolbar-title {{ dialogContent.title }}
        v-spacer
        v-toolbar-items
          v-btn(
            icon
            dark
            @click="dialog = false")
            v-icon close
      conponent(
        v-if="dialog"
        ref="dialogContentForm"
        :is="dialogContent.value"
        :user="edittingUser"
        @update-succeed="updateSucceed"
        @cancel="dialog = false")
  v-dialog(
    v-model="info"
    max-width="500")
    v-card
      v-toolbar(
        dark
        card
        color="indigo")
        v-toolbar-title 會員資料明細
        v-spacer
        v-toolbar-items
          v-btn(
            icon
            dark
            @click="info = false")
            v-icon close
      v-card-text
        user-info(
          v-if="info"
          :user="edittingUser")

</template>

<script>
import remove from "lodash/remove";
import get from "lodash/get";
import { mapGetters } from "vuex";
import UserReceiptTable from "@/components/tables/UserReceiptTable.vue";
import ReceiptCreationStepper from "@/components/ReceiptCreationStepper.vue";
import AccountCreateForm from "@/components/forms/AccountCreateForm.vue";
import PasswordUpdateForm from "@/components/forms/PasswordUpdateForm.vue";
import AccountUpdateForm from "@/components/forms/AccountUpdateForm.vue";
import ProfileUpdateForm from "@/components/forms/ProfileUpdateForm.vue";
import PermissionUpdateForm from "@/components/forms/PermissionUpdateForm.vue";
import UserDeleteForm from "@/components/forms/UserDeleteForm.vue";
import UserInfo from "@/components/UserInfo.vue";

const headers = [
  { text: "查看", value: "look", align: "center" },
  { text: "編輯", value: "edit", align: "center" },
  { text: "姓名", value: "displayName", align: "center" },
  { text: "姓", value: "firstName", align: "center" },
  { text: "編號", value: "number", align: "center" },
  { text: "職稱", value: "jobs", align: "center" },
  { text: "地區", value: "region", align: "center" },
  { text: "性別", value: "gender", align: "center" },
  { text: "最新年度收據", value: "lastYearReceipts", align: "center" },
  { text: "職業", value: "career", align: "center" },
  { text: "家鄉", value: "homeland", align: "center" },
  { text: "生日", value: "birth", align: "center" },
  { text: "電子信箱", value: "email", align: "center" },
  { text: "電話", value: "phoneNumber", align: "center" },
  { text: "電話2", value: "phoneNumber_2", align: "center" },
  { text: "地址", value: "address", align: "left" },
  { text: "郵遞區號", value: "zipCode", align: "center" },
  { text: "備註", value: "remarks", align: "center" },
  { text: "衣服尺寸", value: "tshirtSize", align: "center" },
  { text: "隱藏", value: "hide", align: "center" },
  { text: "uid", value: "uid", align: "left" }
];

const ACTIONS = [
  {
    title: "查看繳費記錄",
    value: "UserReceiptTable",
    permission: [
      "super",
      "admin",
      "manager",
      "all_director",
      "north_director",
      "south_director",
      "director"
    ]
  },
  {
    title: "新增電子收據",
    value: "ReceiptCreationStepper",
    permissions: [
      "super",
      "admin",
      "manager",
      "all_director",
      "north_director",
      "south_director",
      "director"
    ]
  },
  {
    title: "編輯個人資料",
    value: "ProfileUpdateForm",
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "啟用帳號",
    value: "AccountCreateForm",
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "管理權限",
    value: "PermissionUpdateForm",
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "修改密碼",
    value: "PasswordUpdateForm",
    permissions: ["super", "admin"]
  },
  {
    title: "刪除會員",
    value: "UserDeleteForm",
    permissions: ["super", "admin", "manager"]
  }
  /*
  {
    title: '修改帳號',
    value: 'AccountUpdateForm',
    permissions: ['super', 'admin']
  },
  */
];

export default {
  name: "UserTable",
  components: {
    UserReceiptTable,
    ReceiptCreationStepper,
    ProfileUpdateForm,
    AccountCreateForm,
    PermissionUpdateForm,
    PasswordUpdateForm,
    AccountUpdateForm,
    UserDeleteForm,
    UserInfo
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      search: "",
      sheet: false,
      dialog: false,
      dialogContent: {},
      info: false,
      headers,
      loading: false,
      dialogMessage: "",
      edittingUser: null
    };
  },
  computed: {
    ...mapGetters("auth", ["role"]),
    activeActions() {
      const actions = ACTIONS.filter(item =>
        item.permissions ? item.permissions.some(p => p === this.role) : true
      );

      if (get(this.edittingUser, "actived")) {
        remove(actions, action => action.value === "AccountCreateForm");
      } else {
        remove(actions, action => action.value === "AccountUpdateForm");
        remove(actions, action => action.value === "PermissionUpdateForm");
        remove(actions, action => action.value === "PasswordUpdateForm");
      }

      return actions;
    },
    editable() {
      return [
        "super",
        "admin",
        "manager",
        "all_director",
        "north_director",
        "south_director",
        "director"
      ].some(p => p === this.role);
    },
    activeHeaders() {
      return this.editable ? headers : headers.splice(1, 1);
    }
  },
  watch: {
    sheet(v) {
      if (v === false) this.edittingUser = null;
    },
    info(v) {
      if (v === false) this.edittingUser = null;
    }
  },
  methods: {
    openSheet(user) {
      this.edittingUser = user;
      this.sheet = true;
    },
    openDialog(action) {
      this.dialog = true;
      this.dialogContent = action;
    },
    openInfo(user) {
      this.edittingUser = user;
      this.info = true;
    },
    updateSucceed() {
      this.$emit("update-succeed");
      this.dialog = false;
      this.sheet = false;
    }
  }
};
</script>
